/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2016 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * Core initialization route for the New extension.
 * Loads all the data in correct order.
 */
function init() {
	// start loading in all the scripts
	tophat.path('./js/');

	// @ifdef DEBUG
	iaw.perf.markStart(window.loadTime); // set the beginning of performance marking
	iaw.perf.set(iaw.perf.timers.CORELIBS);
	// @endif

	// load head and iaw to start things off
	tophat(['fnft-head.js', 'fnft-iaw.js'], function() {
		// @ifdef DEBUG
		iaw.perf.measure(iaw.perf.timers.CORELIBS);
		iaw.perf.setHighBeamMode(true, iaw.analytics.pip.fnftCategory); // setup HighBeam for point products
		// @endif

		var hostData = null;

		// create data store and attach listeners to it so we know when the data is ready to use
		iaw.store = new Baobab({}, {
			immutable: false,
			persistent: false
		});

		// @ifdef DEBUG
		iaw.perf.set(iaw.perf.timers.DataTime);
		iaw.perf.set(iaw.perf.timers.HostData);
		// @endif

		// get the host app personalization data immediately
		if (window.__adobe_cep__) {
			var hostID = iaw.cepUtil.applicationID;
			var hostIDlc = hostID.toLowerCase();
			var loadAppScript = false;

			// disable right click menu
			document.oncontextmenu = function() { return false; };

			switch (hostIDlc) {
				case 'phxs':
					loadAppScript = true;
					break;
			}
			iaw.log.console('CEP extension for ' + hostID + ' initializing - acquiring host data...');

			// this host needs special help with parsing data
			if (loadAppScript) {
				tophat('app-' + hostIDlc + '.js', function() {
					iaw.apps[hostIDlc].init(boot.receivedHostData, 'fnft');
				});
			}
			else {
				// this host loads the old way, so we call into XS from here
				iaw.cepUtil.evalExtendScript('CCXWelcomeXSHost_' + hostID + '.getUserJSONData("fnft")', function(jsData) {
					if (!jsData) {
						iaw.log.console('Cmd-N extension host data ' + jsData + ' so return');
						return;
					}
					try {
						hostData = JSON.parse(jsData, iaw.json.fnftDataReceiver);
					}
					catch (err) {
						iaw.log.console('Cmd-N extension host data in catch block: ' + jsData);
						iaw.log.exception(err);
					}
					// check if our parse went ok
					boot.receivedHostData(hostData);
				});
			}
		}
		else {
			boot.initHost(iaw.fnftFakeHostData);
			boot.initPresets(iaw.fnftPresetData);
			boot.initTemplates(iaw.fnftFakeStockData, iaw.fnftFakeLicensedTemplates);
		}

		// @ifdef DEBUG
		iaw.perf.set(iaw.perf.timers.UI);
		// @endif

		// register the status changed event for the AI/ID field calculation update from the host
		if (window.__adobe_cep__ && !iaw.cepUtil.oneTimeHandler) {
			iaw.cepUtil.oneTimeHandler = true;
			iaw.cepUtil.csInterface.addEventListener(iaw.cepUtil.events.UPDATEDATACALC, iaw.fnft.handleUpdateCalcData);
		}

		// now that the initial logic is done, start loading in the ui
		tophat(['fnft-uilib.js', 'spectre-ui.min.js'], function() {
			// console.log('----- ui lib ready');
			// riot now exists, so bring in the components
			tophat(['fnft-ui.js'], function() {
				// @ifdef DEBUG
				iaw.perf.measure(iaw.perf.timers.UI);
				// @endif
				window.boot.riotReady = true;
				window.boot.mountApp();
			});
		});
	});
}

/*
	Callbacks
*/
window.boot = {
	riotReady: false,
	hostReady: false,
	appMounted: false,
	stringsReady: false,

	/**
	 *	Called to load as soon as both riot lib and host data are ready
	 */
	mountApp: function() {
		if (boot.appMounted || !boot.riotReady || !boot.hostReady || !boot.stringsReady) return;
		boot.appMounted = true;
		// Disable all transitions to speed up initial mount.
		var oldClass = document.documentElement.className;
		document.documentElement.className += ' loading';

		iaw.perf.set('riot.mount.app');
		riot.mount('container-templates');
		riotctrl.trigger('update-spcmixin-retro');
		iaw.perf.measure('riot.mount.app');
		// let the host know we are finished for the most part
		iaw.perf.measure(iaw.perf.timers.InteractiveTime, window.loadTime);
		iaw.cepUtil.sendEvent(iaw.cepUtil.events.INTERACTIVEREADY, null);
		iaw.interactiveReady = true;
		setTimeout(function(params) {
			document.documentElement.className = oldClass;
			window.boot.lateLoad();
		}, 0);
	},

	patchHostData: function(hostData) {
		var userId = '';
		if (window.profile && window.profile.hasValidUser()) {
			var profile = JSON.parse(window.profile.getProfile());
			var relationship = profile.RelationshipProfile.find(function(x) { return x.usedForLegacyProfile; });
			Object.assign(hostData, {
				adobeGUID: profile.UserProfile.userId,
				firstName: profile.UserProfile.firstName,
				lastName: profile.UserProfile.lastName,
				countryCode: profile.UserProfile.countryCode,
				accountType: profile.UserProfile.accountType,
				accountStatus:
				(profile.LegacyProfile.licenseType === 1? 'trial': 'paid'),
				secondsLeftInTrial: relationship ? new Date(relationship.licenseExpiryTimestamp).getTime() - Date.now() : 0
			});
			userId = profile.UserProfile.userId;
		}
		else {
			// Offline or FRL mode. Show no templates.
			Object.assign(hostData, {
				adobeGUID: '',
				firstName : '',
				lastName : '',
				countryCode : '',
				accountType : '',
				accountStatus : 'paid',
				secondsLeftInTrial : 0
			});
		}

		iaw.cepUtil.csInterface.addEventListener('com.adobe.csxs.events.ProfileChanged', function() {
			if (window.profile.hasValidUser()) {
				var profile = JSON.parse(window.profile.getProfile());
				if (profile.UserProfile.userId !== userId) {
					window.location.reload();
				}
			}
			else if (userId !== '') {
				window.location.reload();
			}
		});
	},

	/**
	 *	Callback for host data event in CEP only
	 */
	receivedHostData: function(hostData) {
		if (hostData) {
		boot.patchHostData(hostData);
		hostData.radarVersion = window.buildVersion;
		hostData.radarSessionGUID = iaw.util.generateGUID();

		boot.initHost(hostData);
	}
	},

	/**
	 * After host data is loaded, initialize the app
	 */
	initHost: function(hostData) {
		if (!hostData) return;
		// @ifdef DEBUG
		iaw.perf.measure(iaw.perf.timers.HostData);
		// @endif

		// configure authentication servers
		hostData.ingestServer = 'prod';

		if (!iaw.cepUtil.usingStageAuthentication()) {
			iaw.log.console('Authentication environment to production');
		}
		else {
			iaw.cepUtil.setEnvironment('stage');
			hostData.ingestServer = 'stage';
			iaw.log.console('Authentication environment to stage');
		}

		// @ifdef DEBUG
		iaw.perf.set(iaw.perf.timers.InitHost);
		// @endif

		// add filters & template data from host
		hostData.filters = iaw.fnft.generateFilters(hostData.hostID);
		iaw.localstorage.userID = hostData.adobeGUID;

		// display count
		hostData.displayCount = parseInt(iaw.localstorage.getUserItem('fnft.displayCount') || 0) + 1;
		iaw.localstorage.setUserItem('fnft.displayCount', hostData.displayCount);

		iaw.store.set('host', hostData);

		iaw.perf.set('i18n json');
		// add go URL localization maps
		iaw.i18n.addFromURLFile('goURL');
		iaw.i18n.addFromLocalLocaleFile(hostData.language, function(evt) {
			iaw.perf.measure('i18n json');
			riotctrl.trigger('update-i18n-retro');
			window.boot.stringsReady = true;
			window.boot.mountApp();
		});

		// Set the current settings to blank so that the rest
		// of the the code can append to them.
		iaw.store.set(['input', 'settings'], {});

		// log the finalize data
		if (window.__adobe_cep__) {
			iaw.log.logJSONDelayed('host.data: ', hostData);
		}

		// start our resize/RWD/DOM update tool
		iaw.motor.start();
		iaw.startup.run(iaw.startup.PHASES.Doc); // fnft doesn't have a doc load event, so this is good enough
		iaw.startup.run(iaw.startup.PHASES.Host);

		// @ifdef DEBUG
		iaw.perf.measure(iaw.perf.timers.InitHost);
		// @endif

		if (hostData.platform === 'mac') {
			// mac gets special treatment to allow "cmd+period" to close the dialog
			var comboCmd = false;
			var comboPer = false;
			document.addEventListener('keydown', function(evt) {
				if (evt.which === 91) comboCmd = true;
				if (evt.which === 190) comboPer = true;
				if (comboCmd && comboPer) {
					window.__adobe_cep__.closeExtension();
				}
			}, false);
			document.addEventListener('keyup', function(evt) {
				if (evt.which === 91) comboCmd = false;
				if (evt.which === 190) comboPer = false;
			}, false);
		}

		if (!window.__adobe_cep__) return;

		// get the preset data from host
		iaw.log.console('CEP extension for '+hostData.hostID+' initializing - acquiring preset data...');

		// @ifdef DEBUG
		iaw.perf.set(iaw.perf.timers.HostPresetData);
		// @endif

		var hostIDlc = hostData.hostID.toLowerCase();

		if (iaw.apps && iaw.apps[hostIDlc]) {
			iaw.apps[hostIDlc].initPresets(window.boot.initPresets, 'fnft');
		}
		else {
			boot.initPresets(hostData.templates);
		}
	},

	// presets have been loaded
	initPresets: function(presetData) {
		var presetLUT = {};

		var hostId = iaw.store.get(['host', 'hostID']);
		for (var i = 0; i < presetData.length; i++) {
			var uuid = iaw.util.generateGUID();

			presetData[i].uuid = uuid;
			// Workaround to convert preset's lastUsedTime of AI to local time
			if (hostId === 'ILST' && presetData[i].lastUsedTime) {
				presetData[i].lastUsedTime += (new Date().getTimezoneOffset() * 60000);
			}
			presetLUT[uuid] = i;
		}

		iaw.store.set('presets', presetData);
		iaw.store.set('presetLUT', presetLUT);

		if (window.__adobe_cep__) {
			iaw.log.logJSONDelayed('presets.data', presetData);
			iaw.log.logJSONDelayed('presets.lut', presetLUT);
		}

		// @ifdef DEBUG
		iaw.perf.measure(iaw.perf.timers.HostPresetData);
		// @endif

		// fill the grid with presets
		riotctrl.trigger('update-host-retro');

		// If there is a high probability of there being stock templates in the recent
		// list then fetch those before mounting the UI.
		if (window.__adobe_cep__ && iaw.localstorage.getUserItem('hasStock') !== false) {
			boot.getTemplates();
			window.boot.initMarkdown();
		}

		window.boot.hostReady = true;
		window.boot.mountApp();

		// If the likelihood of stock templates in the recent list is low, launch with
		// presents only and patch up stock templates later.
		if (window.__adobe_cep__ && iaw.localstorage.getUserItem('hasStock') === false) {
			boot.getTemplates();
		}
	},

	// initialize data fetch
	getTemplates: function() {
		var hostData = iaw.store.get('host');

		function handleStockData(stockData) {
			// @ifdef DEBUG
			iaw.perf.measure(iaw.perf.timers.StockData);
			iaw.perf.set(iaw.perf.timers.LicensedData);
			// @endif

			var sd = stockData || iaw.fnft.generateDefaultStockData(hostData);
			iaw.log.logJSONDelayed('stock.data: ', sd);
			// For the sake of getting best performance, the idea is to retrieve cached licensed template from CC library snapshot directly
			// rather than loading the cc library js file and init it. This probably saves up more than 400ms.
			iaw.libraryManager.getCachedTemplates(hostData.hostID, function(licensedTemplates) {
				if (!Array.isArray(licensedTemplates) || licensedTemplates.length === 0) {
					iaw.localstorage.setUserItem('hasStock', false);
				}
				else {
					iaw.localstorage.setUserItem('hasStock', true);
				}
				// @ifdef DEBUG
				iaw.perf.measure(iaw.perf.timers.LicensedData);
				iaw.perf.measure(iaw.perf.timers.DataTime);
				// @endif
				boot.initTemplates(sd, licensedTemplates);
			});
		}

		// Getting stock templates is very slow.
		// So here is a trick that we use.
		// We cache the stock data after first launch and then on each subsequent launch
		// we first render with the cached data and then reinitialize the templates from
		// by fetching afresh from the CCX Process.
		// The stock data has expiration to it. So if that expires, we do swap that
		// data out but do so lazily after the initial load.
		iaw.perf.set(iaw.perf.timers.StockData);
		var cachedStockData = iaw.localstorage.getGlobalItem('stockData');
		if (cachedStockData) {
			handleStockData(cachedStockData);

			// if (new Date(cachedStockData.expirationDTS) < new Date()) {
			riotctrl.on('update-details-retro', function() {
					iaw.perf.set(iaw.perf.timers.StockData);
					iaw.fnft.getStockData(hostData, function(stockData) {
						iaw.localstorage.setGlobalItem('stockData', stockData);
						iaw.log.debug('Patch up stock data');
						handleStockData(stockData);
					});
				});
			// }
		}
		else {
			iaw.fnft.getStockData(hostData, function(stockData) {
				iaw.localstorage.setGlobalItem('stockData', stockData);
				handleStockData(stockData);
			});
		}
	},

	// populate the UI with the templates after it's been loaded
	initTemplates: function(stockData, licensedTemplates) {
		iaw.perf.set(iaw.perf.timers.TemplateFixup);
		// move all the licensed templates into the recent tab and update the
		// last used time so they sort correctly with the presets
		var licensedTemplatesLUT = {};
		var templateCount = licensedTemplates.length;
		var tIndex = 0;

		// TODO: we should initializing an empty array only, after we split out the presets
		var templates = [];
		licensedTemplates = licensedTemplates || [];

		for (tIndex; tIndex < templateCount; ++tIndex) {
			licensedTemplatesLUT[licensedTemplates[tIndex].id] = tIndex;
			// licensedTemplates[tIndex].template_category = ["recent"]; // eslint-disable-line camelcase
			// licensedTemplates[tIndex].lastUsedTime = licensedTemplates[tIndex].modified;
		}

		if (window.__adobe_cep__) {
			iaw.log.logJSONDelayed('licensed.data: ', licensedTemplates);
		}

		// lastUsedTime priority: host > local cache > cc library
		var presets = iaw.store.get('presets');
		if (presets) {
			presets.forEach(function(preset) {
				if (preset && (!preset.isPreset)) {
					var id = iaw.libraryManager.getIdByCachedElementRef(preset.elementRef) || iaw.libraryManager.getIdByElementRef(preset.elementRef);
					iaw.localstorage.setUserItem('templateLUT_' + id, preset.lastUsedTime);
				}
			});
		}

		// merge in stock data
		if (stockData && stockData.templates) {
			templateCount = stockData.templates.length;
			for (tIndex = 0; tIndex < templateCount; ++tIndex) {
				var stockTemplate = stockData.templates[tIndex];
				var licensedDataIndex = licensedTemplatesLUT[stockTemplate.id];

				if (licensedDataIndex !== undefined) {
					var licensedData = licensedTemplates[licensedDataIndex];

					stockTemplate.url = licensedData.url;
					stockTemplate.elementRef = licensedData.elementRef;
					stockTemplate.lastUsedTime = iaw.localstorage.getUserItem('templateLUT_' + stockTemplate.id) || licensedData.modified;
					stockTemplate.licensedTime = licensedData.modified;
					stockTemplate.thumbnail_url = licensedData.thumbnail_url; // eslint-disable-line camelcase
					stockTemplate.template_category.push('recent');	// eslint-disable-line camelcase
					stockTemplate.template_category.push('saved'); // eslint-disable-line camelcase
				}
				// make sure all templates have a lastUsedTime parameter defined
				if (stockTemplate.lastUsedTime === undefined) {
					stockTemplate.lastUsedTime = 0;
				}
				// make sure all templates have a licensedTime parameter defined
				if (stockTemplate.licensedTime === undefined) {
					stockTemplate.licensedTime = 0;
				}
				templates.push(stockTemplate);
			}
		}

		// merge the licensed templates to the master list
		var templateIds = {};
		templates = templates.concat(licensedTemplates);
		templates = templates.filter(function(template, pos) {
			if (!templateIds[template.id]) {
				templateIds[template.id] = true;
				return true;
			}
			return false;
		});

		// add UUID's to all templates & presets, and build quick reference lookup table
		var templateLUT = {};
		templateCount = templates.length;

		templates.sort(function(a, b) {
			return b.lastUsedTime - a.lastUsedTime;
		});

		for (tIndex = 0; tIndex < templateCount; ++tIndex) {
			var uuid = iaw.util.generateGUID();

			templates[tIndex].uuid = uuid;
			templateLUT[uuid] = tIndex;
		}

		var holder = document.createDocumentFragment();
		templates.find(function(template, index) {
			// Pre-fetch the template thumbnail
			var linkElement = document.createElement('link');
			linkElement.rel = 'preload';
			linkElement.href = template.thumbnail_url;
			linkElement.as = 'image';
			holder.appendChild(linkElement);
			return index >= iaw.fnft.NUMBER_OF_ITEMS_ABOVE_FOLD;
		});
		document.body.appendChild(holder);

		iaw.store.set('templates', templates);
		iaw.store.set('templateLUT', templateLUT);

		iaw.startup.run(iaw.startup.PHASES.Done);

		// make sure the active item still retains keyboard focus
		var activeItem = document.querySelector('.preset-grid-item--active');
		if (!activeItem) {
			// maybe a template is active, not a preset
			activeItem = document.querySelector('.template-grid-item--active');
		}
		if (activeItem) {
			activeItem.focus();
		}

		if (window.__adobe_cep__) {
			iaw.log.logJSONDelayed('templates.data', templates);
			iaw.log.logJSONDelayed('templates.lut', templateLUT);
		}
		iaw.perf.measure(iaw.perf.timers.TemplateFixup);
	},

	initMarkdown: function() {
		if (!iaw.initMarkdown) {
			iaw.initMarkdown = true;
			tophat(['marked.min.js'], function() {
				// notify app
				riotctrl.trigger('markdown-ready-retro');
			});
		}
	},

	lateLoad: function() {
		// last scripts that we need which aren't used until the user interacts with something
		iaw.perf.set(iaw.perf.timers.JSLibLateLoad);

		// set the title for the debugger so we know what we are using
		document.title = iaw.cepUtil.getExtensionID();
		// add theme change event listener
		iaw.cepUtil.addThemeChangeListener();

		// add host close listener
		iaw.cepUtil.csInterface.addEventListener(iaw.cepUtil.events.HOSTCLOSEFNFT, function() {
			window.__adobe_cep__.closeExtension();
		});

		riotctrl.on('reload-sidebar', function() {
			// Clear the stored document name that has been cached.
			// We are so quick that the user will not have the opportunity
			// To write it anyways.
			// https://jira.corp.adobe.com/browse/IAW-4007
			iaw.store.set(['input', 'doc-name'], undefined);
			// Case 1: Sidebar content has not been reloaded.
			var type, data;
			var sidebar = document.getElementsByClassName('sidebar-content')[0];
			if (sidebar) {
				type = sidebar.tagName.toLowerCase();
				data = sidebar._tag.data;
			}
			// Case 2: The sidebar has been reloaded once and the the container has the contents.
			else {
				var container = document.getElementById('sidebar-container');
				type = container.dataset.is;
				data = container._tag.data;
			}
			riot.mount('#sidebar-container', type, data);
		});

		riotctrl.trigger('update-details-retro');
		window.boot.initMarkdown();

		tophat(['fnft-lib.js'], function() {
			// configure Ingest
			if (typeof Ingest !== 'undefined') {
				iaw.perf.measure(iaw.perf.timers.JSLibLateLoad);
				iaw.perf.set(iaw.perf.timers.INGESTCONFIG);

				var hostData = iaw.store.get('host');

				iaw.analytics.config('ccx-cmdn-service', hostData, null, hostData.ingestServer);
				iaw.perf.measure(iaw.perf.timers.INGESTCONFIG);

				//send an event to the host app with the end time
				var fnftLoadingEndTime = iaw.util.getCurrentTime();

				iaw.log.console('Cmd-N loading ends at: ' + fnftLoadingEndTime);
				iaw.cepUtil.sendEvent(iaw.cepUtil.events.FNFTENDTIME, fnftLoadingEndTime.toString());
				iaw.perf.report(true);
				iaw.perf.measure(iaw.perf.timers.LoadTime, window.loadTime);
			}
			// The scripts loaded by tophat till now are cached in production
			// in window.localstorage so that on subsequent runs, we save on the
			// fetch from disk time and also run everything on the blocking main thread
			// and prevent any repaints before the initial screen is loaded.
			// The current place is a good spot where all the scripts have been requested.
			tophat.cache();
		});

		// Delay load & init cc Libraries.
		iaw.libraryManager.init(iaw.libraryManager.TEMPLATE_ELEMENT_TYPE);
		// @endif
	}
};

/**
 * Add event listeners for drag/drop for the dashboard/panel.
 */
window.addEventListener('dragover', function(e) {
	e = e || event;
	// prevent default to allow drop
	e.preventDefault();
}, false);

window.addEventListener('drop', function(e) {
	e = e || event;
	e.preventDefault();
}, false);

window.addEventListener('dragstart', function(e) {
	e = e || event;
	// Prevent browser-default drag behavior
	e.preventDefault();
}, true);

window.addEventListener('hashchange', function(e) {
	e = e || event;
	e.preventDefault();

	var h = iaw.util.parseQueryString(location.hash);
	riotctrl.trigger('hashchange', h);
}, false);

// immediately set the theme so there's no flashing colors
if (window.__adobe_cep__) {
	var interfaceColor = iaw.cepUtil.csInterface ? iaw.cepUtil.getUIThemeColor() : null;
	if (interfaceColor && interfaceColor.red >= 184) {
		document.body.classList.remove('spc--dark');
	}
}

document.addEventListener('keypress', function(e) {
	if (e.keyCode === 27) {
		window.__adobe_cep__.closeExtension();
	}
	if (e.keyCode === 13) {
		iaw.hasPendingEnter = true;
	}
});

init();
